



















































































































































































































































import Vue from 'vue';
import { rrulestr } from 'rrule';
import { Day } from 'dayspan';
import dateFormat from '@/utils/dateFormat';
import { localDateFormat } from '@/utils/dateHelpers';
import { Contact } from '@/models/contact';

export default Vue.extend({
  props: {
    event: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    localDateFormat,
    dateFormat,
    cancel() {
      this.$emit('close', false);
    },
    deleteOcc(event: any) {
      this.$emit('delete', event);
    },

    getRsvpIcon(rsvp: number): string {
      switch (rsvp) {
        case 0:
          return 'mdi-close';
        case 1:
          return 'mdi-check';
        case 2:
          return 'mdi-help';
        default:
          return 'mdi-help';
      }
    },
    getRsvpColor(rsvp: number): string {
      switch (rsvp) {
        case 0:
          return 'red lighten-2';
        case 1:
          return 'success';
        case 2:
          return 'grey';
        default:
          return 'grey';
      }
    },
    getAttendeeInitials(contact: Contact) {
      return (
        contact.name.first.substring(0, 1).toUpperCase() +
        contact.name.last.substring(0, 1).toUpperCase()
      );
    }
  },
  computed: {
    Day: () => Day,
    rrulestr: () => rrulestr
  }
});
